<template>
    <div class="PoolResult">
        <!-- 下拉框选择部分 -->
        <div class="PoolResult_header">
            <div class="">{{PhaseName}}</div>
        </div>
        <!-- tab部分 -->
        <div>
            <el-row>
                <el-button v-for="(i,index) in ResultListArr" :key="index" :class="active == index ? 'activeCLass' : ''" @click="handleGroup(i.PhaseID,index,i.IsShowOld)">{{i.PhaseName}}</el-button>
                <!-- <el-button>第三阶段-三、四名决赛</el-button>
                <el-button>第三阶段-半决赛</el-button>
                <el-button>第三阶段-冠亚军决赛</el-button> -->
            </el-row>
        </div>
        <!-- 内容部分 -->
        <div class="PoolResult_box">
            <el-scrollbar :native="false" tag="section">
            <el-table
                :data="ResultArr"
                :header-cell-style="{'textAlign': 'center','background':'#eaeaea'}"
                :cell-style="{ textAlign: 'center' }"
                :row-class-name="TableRowClassName"
                style="width: 100%">
                
                <!-- <el-table-column
                prop="date"
                label="名次"
                width="80">
                    <template slot-scope="scope">
                        <div>{{scope.row.Points}}</div>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="date"
                label="球队"
                >
                    <template slot-scope="scope">
                        <div>{{ scope.row.RegisterName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="date"
                label="积分"
                width="80">
                    <template slot-scope="scope">
                        <div>{{scope.row.Points}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="比赛">
                    <el-table-column
                    prop="province"
                    label="总场数"
                    width="70">
                        <template slot-scope="scope">
                            <div>{{scope.row.MatchNum}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="胜"
                    width="40">
                        <template slot-scope="scope">
                            <div>{{scope.row.MatchWin}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="负"
                    width="40">
                        <template slot-scope="scope">
                            <div>{{scope.row.MatchLost}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="局">
                    <el-table-column
                    prop="province"
                    label="胜"
                    width="40">
                        <template slot-scope="scope">
                            <div>{{scope.row.GameWin}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="负"
                    width="40">
                        <template slot-scope="scope">
                            <div>{{scope.row.GameLost}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="分数">
                    <el-table-column
                    prop="province"
                    label="总得分"
                    width="70">
                        <template slot-scope="scope">
                            <div>{{scope.row.PointsWin}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="总失分"
                    width="70">
                        <template slot-scope="scope">
                            <div>{{scope.row.PointsLost}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="比赛结果统计">
                    <el-table-column
                    prop="province"
                    label="3-0"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_3_0}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="3-1"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_3_1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="3-2"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_3_2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="2-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_2_3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="1-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_1_3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="0-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.F_0_3}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column 
                label="C值"
                width="60"
                >
                    <template slot-scope="scope">
                        <div>{{scope.row.ValueC}}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                label="Z值"
                width="60"
                >
                    <template slot-scope="scope">
                        <div>{{scope.row.ValueZ}}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                label="判罚"
                width="60">
                    <template slot-scope="scope">
                        <div>{{scope.row.IRM}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="前期比赛带入成绩" v-if="IsShowOld != 0">
                    <el-table-column
                    prop="province"
                    label="SP"
                    width="50">
                    <template slot-scope="scope">
                        <div>{{scope.row.OPoints}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="3-0"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_3_0}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="3-1"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_3_1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="3-2"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_3_2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="2-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_2_3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="1-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_1_3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="0-3"
                    width="50">
                        <template slot-scope="scope">
                            <div>{{scope.row.O_0_3}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
            
            </el-table>
        </el-scrollbar>
        </div>

    </div>
</template>

<script>
import http from '@/assets/js/http.js';
export default {
    data() {
      return {
        tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-08',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-06',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-07',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }],
        PhaseID: 0,
        ResultArr:[],
        ResultListArr:[],
        IsShowOld: 0,
        active: 0,
        PhaseName:'',
        my_data: null,
      }
    },
    props: ['phase'],
    watch: {
        phase(newVal,oldVal){
            // console.log('这是新值111:'+newVal)
            // console.log('这是laozh1111i:'+oldVal)
            this.active = 0;
            this.GetGroupResult(newVal)//获取小组赛积分成绩
        },
        $route: { // 亲测有效,我是用来监听query参数变化
            handler(newVal,oldVal) {
                // this.id = this.$route.query.id;
                // this.getDetail();
                // console.log('这是新值:',newVal)
                // console.log('这是laozhi:',oldVal)
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                // console.log(params)
                this.PhaseID = params.phaseID;
                this.PhaseName = params.phaseName;
                
            },
            deep: true,
        }
    },
    created(){
        let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        this.my_data = params;
        this.PhaseID = params.phaseID;
        this.PhaseName = params.phaseName;
        // console.log(params)
    },
    mounted(){
        this.PhaseID = this.$cookie.get('PhaseID');
        this.GetGroupResult(this.PhaseID)//获取小组赛积分成绩
    },
    methods: {
        TableRowClassName({row, rowIndex}) {
            if ((rowIndex+1)%2==0) {
                return 'statistics-warning-row';
            } else {
                return '';
            }
        },
        handleGroup(val,index,IsShowOld){//点击上面的组别
        // console.log(val,index,IsShowOld)
            this.active = index;
            for(let i = 0; i < this.ResultListArr.length;i++){
                let item = this.ResultListArr[i];
                if(val == item.PhaseID){
                    this.ResultArr = item.GroupPoints;
                    this.IsShowOld = item.IsShowOld;
                }
            }
        },
        GetGroupResult(PhaseID){//获取小组赛积分成绩
            http.GetGroupResult(PhaseID).then(res=>{////获取小组赛积分成绩
                console.log(res)
                if(res.Status == 1){
                    // this.JsonData = res.DataResult;
                    if(res.DataResult.length > 0){ 
                        this.ResultListArr = res.DataResult;
                        this.ResultArr = this.ResultListArr[0].GroupPoints;
                        this.IsShowOld = this.ResultListArr[0].IsShowOld;
                    }else{
                        this.ResultListArr = [];
                        this.$message.error('暂无数据啦');
                    }
                    
                }else if(res.Status == 0){
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.$message.error({
                        message:'获取信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-table__row.statistics-warning-row {
        background: #ddd;
    }
    .PoolResult{
        max-width: 1200px;
        margin: 20px auto;
        font-size: 16px;
        // background: white;
    }
    .PoolResult_header{
        text-align: left;
        font-size: 20px;
        font-weight: bold;
    }
    .PoolResult_box{
        width: 100%;
        margin-top: 20px;
    }
    .activeCLass{
        color: #409EFF;
        background-color: #ecf5ff;
        border-color: #c6e2ff; 
        // outline-color: rgb(64, 158, 255); 
    }
</style>
